/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'not-started': {
    viewBox: '0 0 32 32',
    data: `<path d="M16,31C7.7,31,1,24.3,1,16C1,7.7,7.7,1,16,1c8.3,0,15,6.7,15,15C31,24.3,24.3,31,16,31z M16,3C8.8,3,3,8.8,3,16
    c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13C29,8.8,23.2,3,16,3z"/>`
  }
})
